<template>
    <b-overlay :show="tableLoading" rounded="sm" >
        <b-card class="inner-block health-listing">
            <b-card-header>
                <import-form
                :subject="$translate('user_roster')"
                v-model="importModal"
                @cancel="hideModal()"
                :fields="inventoryFields"
                :upload-record="uploadInventoryRecord"
                :isuserroster="isUserRoster"
                settings-key-name="UserRosterUploadKey"
              ></import-form>
                <b-row class="mt-2">
                   
                    <!-- <b-col cols="2" md="1" lg="1"
                        class="d-flex align-items-center justify-content-center"><strong>health</strong></b-col>
                    <b-col cols="10" md="11" lg="11" class="d-flex"> -->
                    <b-col cols="12"  class="d-flex gap-1 gap-md-2 ps-3 mt-1 mt-md-0 align-self-baseline align-self-md-center master-item-button"
                    >
                        <b-input type="text" :placeholder="$translate('search_filter')" v-model="query"></b-input>
                        
                 
                        <b-button
                        id="add-checkoff-btn"
                        variant="blue-icon"
                        v-b-tooltip.hover
                        :title="$addLabel()"
                        v-if="hasPermissionCreate"
                        @click="addRoster"
                        >
                        <img src="@/assets/images/icon/gradient-add.svg" />
                        </b-button>
          
                        <b-button
                        id="import-checkoff-item-btn"
                        variant="blue-icon"
                        v-b-tooltip.hover
                        :title="$translate('import')"
                        @click="openModel()"
                        v-if="hasPermissionCreate"
                      >
                        <img src="@/assets/images/icon/import.svg" />
                      </b-button>
                      <b-button
                      id="export-checkoff-item-btn"
                      variant="blue-icon"
                      v-b-tooltip.hover
                      :title="$translate('export')"
                      @click="export_roster()"
                      v-if="hasPermissionCreate"
                    >
                      <img src="@/assets/images/icon/export.svg" />
                    </b-button>
                     <b-button id="reset-filter-btn" variant="blue-icon" @click="resetFilters" v-b-tooltip.hover
                         :title="$translate('reset_filters')">
                         <b-icon icon="arrow-repeat" class="fs-2" variant="dark" style=" font-size: 1.5rem"></b-icon>
                     </b-button>
                     <b-button variant="blue-icon" id="toggle-filter-btn"  v-if="hasPermissionView" class="me-2"
                     @click="toggle_filters = !toggle_filters" v-b-tooltip.hover
                     :title="$translate('filter')">
                    
                     <b-icon class="fs-2" style=" font-size: 1.5rem" :icon="'chevron-' +
                         (toggle_filters ? 'up' : 'down')
                         " variant="dark"></b-icon>
                 </b-button>
                    </b-col>
                </b-row>
                <roster-filters v-show="toggle_filters" v-model="filters" />
            </b-card-header>
            <b-card-body class="button-off">
                <b-col class="page-block">
                    <strong>
                        {{ $translate('page') }}: {{ pagination.page }} {{ $translate('of') }} {{ pageCount }} {{
                            $translate('total') }}:
                        {{ pagination.total }}
                    </strong>
                </b-col>
                <b-col class="overflow-auto w-100 mt-4">
                    <b-table show-empty :empty-text=" $translate('records_not_found')" id="rosterTable" responsive :items="user_roster" :fields="fields">
                        <template>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <!-- <strong>{{ $translate('loading') }}</strong> -->
                            </div>
                        </template>
                        <template #cell(id)="row">
                            <b-button :id="'view-roster-btn-'+row.item.id" @click="view(row.item.id)"  class="mr-2 test-view-document-type-btn" variant="pink-button">
                                <img src="@/assets/images/icon/view.svg" />
                            </b-button>
                            <!-- <b-button @click="view(row.item.id)" v-if="hasPermissionView" class="mr-2" variant="pink-button">
                                <img src="@/assets/images/icon/view.svg" />
                            </b-button> -->
                        </template>
                     
                    </b-table>
                </b-col>
                <b-row>
                    <b-col>
                        <b-pagination class="justify-content-center mt-4" v-model="pagination.page"
                            :total-rows="pagination.total" :per-page="pagination.pageSize" aria-controls="customerTable"
                            :prev-text="$translate('previous')" :next-text="$translate('next')" pills
                            align="right"></b-pagination>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
    </b-overlay>
</template>
<script>
import _ from 'lodash'

import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import RosterFilters from './RosterFilters.vue'
import importMixins from "@/mixins/importMixins";
import ImportForm from "@/components/ImportForm.vue";

const inventoryFields = [
  { name: "user_name", label: "user_name", required: true, type: "text" },
 
  {
    name: "start_date",
    label: "start_date",
    required: true,
    type: "text",
  },
  {
    name: "end_date",
    label: "end_date",
    required: true,
    type: "text",
  },
  {
    name: "start_time",
    label: "start_time",
    required: true,
    type: "text",
  },
  {
    name: "end_time",
    label: "end_time",
    required: true,
    type: "text",
  },
  {
    name: "shift",
    label: "shift",
    required: false,
    type: "text",
  },
 

];
export default {
    name: 'health-table',
    mixins: [popupMixins, permissionsMixins,importMixins],
    components: {
        RosterFilters,
        ImportForm
       
    },
    props: {
        type: {
            type: String,
        },
        title: String,
    },
    data() {
        return {
            query: '',
            tableLoading: false,
            toggle_filters: false,
            filters: {
                start_date: "",
                end_date : "",
                enableDateTimeFilter: false,
                filter_date: '',
                start_time: '',
                end_time: ''
               
            },
            importModal: false,
            inventoryFields,
            isUserRoster : 'yes',
        }
    },
    computed: {
        fields() {
            return [
                { key: 'id', label: this.$translate('actions') },
                { key: 'user', label: this.$translate('user') ,formatter: (value) => value.first_name+' '+value.last_name  },
                
                { key: 'start_date', label: this.$translate('start_date') },
                { key: 'end_date', label: this.$translate('end_date') },
                { key: 'start_time', label: this.$translate('start_time') },
                { key: 'end_time', label: this.$translate('end_time') },
                { key: 'shift', label: this.$translate('shift') },
               
            ]
        },
        pageCount() {
            return Math.ceil(this.pagination.total / this.pagination.pageSize)
        },
        user_roster() {
            const user_roster = this.$store.state.user_roster.items
           
            return user_roster
        },
        pagination() {
            return this.$store.state.user_roster.pagination || {page: 1}
        },
      
    },

    watch: {
        user_roster: {
            handler: function () {
                this.tableLoading = false
            },
            deep: true,
        },
        'pagination.page': function (newPage) {
            this.changePage(newPage)
        },
        query: _.debounce(function (query) {
            this.$router.push({ query: { query } })
            this.doSearch()
        }, 200),
        filters: {
            handler: function () {
             
                this.doSearch(true)
            },
            deep: true,
        },
    },

    mounted() {
        if (this.$route.query.query) this.query = this.$route.query.query
        this.doSearch()
    },

    methods: {
       
        changePage(page) {
            this.$router.push({ query: { page } })
            this.doSearch()
        },
        resetFilters() {
            this.setDefaultDateRange();
            this.doSearch()
        },
        async doSearch() {
         
            try {
                this.$store.commit('user_roster/updateFilter', {
                                                query: this.query,
                                                filters: this.filters
                                                });
                this.tableLoading = true
                const {
                    pagination: { page },
                    query,
                    filters
                } = this
                await this.$store.dispatch('user_roster/fetch', {
                    query,
                    page,
                    filters
                })
            } catch (error) {
                console.error('loading error', error)
            }
        },
        view(index) {
            const path = `${this.$route.path}/${index}`
            console.log('path---',path);
            this.$router.push({ path })
        },
       
        truncate(text, length) {
            return _.truncate(text, { length: length })
        },
        addRoster() {
            const id = 0
            this.$router.push({ params: { id }, name: 'viewUserRoster' })
        },
        async uploadInventoryRecord(
      dataRecord,
      statusRecord,
      { check, message, field },
      statuses,
      setLoading
    ) {
      try {
        let {
          user_name,
          start_time,
          end_time,
          start_date, 
          end_date,
          shift
      
        } = dataRecord;

     
        user_name = user_name.trim();
        start_time = start_time.trim();
        end_time =end_time.trim();
        start_date = start_date.trim();
        end_date = end_date.trim();
        shift = shift.trim();
       
        const param = {
            user_name,
            start_time,
            end_time,
            start_date, 
            end_date,
            shift
         
        };
        console.log({ param });

        const res = await this.$store.dispatch("user_roster/upload", param);
        this.tableLoading = true;
        this.doSearch();
        this.tableLoading = false;
        // console.log("response:", res);
        // set status to complete if the upload was successful
        statusRecord.status = statuses.COMPLETE;
      } catch (err) {
        // console.error("err", err);
        // statusRecord.error_list =
        //   typeof err.message == "string"
        //     ? [["error", [err.message]]]
        //     : Object.entries(err.message);
        // statusRecord.status = statuses.ERROR;
        console.error("err", err);
        statusRecord.error_list =
          typeof err.message == "string"
            ? [["error", [err.message]]]
            : Object.entries(err.message);
        statusRecord.status = statuses.ERROR;
      } finally {
        // setLoading(false);
      }
    },
    openModel(){
     
      this.importModal = true;   
     },
     async export_roster(){
     
            this.tableLoading = true
            let filter_r = this.$store.state.user_roster.filter;
               let query_r =  this.$store.state.user_roster.query;
           await  this.$store.dispatch('user_roster/exportExcelCSV', {
               
            filter_r,
            query_r
           })
            this.tableLoading = false
     },
     setDefaultDateRange() {
      const currentDate = new Date();
      const currentDay = currentDate.getDay();
      const diffToSunday = currentDay === 0 ? 0 : 7 - currentDay;

      // Calculate the start date (two Sundays ago)
      const startDate = new Date(currentDate);
      startDate.setDate(currentDate.getDate() - currentDay + diffToSunday - 7);

      // Calculate the end date (next Saturday)
      const endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 13);

      // Format dates to YYYY-MM-DD for the date input fields
      const formatDate = (date) => {
        return date.toISOString().split('T')[0];
      };

      this.filters.start_date = formatDate(startDate);
      this.filters.end_date = formatDate(endDate);
      const defaultStartTime = '10:00'; // Default start time
      const defaultEndTime = '19:00'; // Default end time
      this.filters.filter_date = formatDate(currentDate); // Set current date as the filter date
      this.filters.start_time = defaultStartTime;
      this.filters.end_time = defaultEndTime;
    }
     
    },
}
</script>
<style></style>
